/*                                                         */
import { defineEvent } from "@otto-ec/global-resources/nexus";
import type { EventTopicDefinition } from "@otto-ec/global-resources/nexus";
import { get } from "svelte/store";
import * as shared from "./SheetV1.shared";

/**
 *
 *
 */
export const open = (sheetID: string): void => {
  shared.openSheetID.set(sheetID);
};
/**
 *
 */
export const close = (): void => {
  shared.openSheetID.set(null);
};
/**
 *
 */
export const back = shared.goBack;
/**
 *
 */
export const getOpenSheet = (): HTMLOcSheetV1Element | null => {
  return get(shared.openSheet);
};
/**
 *
 */
export const getContent = (): HTMLElement | null => {
  const openSheetElement = getOpenSheet();
  return openSheetElement ? shared.getContent(openSheetElement) : null;
};
/**
 *
 */
export const getHeader = (): HTMLElement | null => {
  const openSheetElement = getOpenSheet();
  return openSheetElement ? shared.getHeader(openSheetElement) : null;
};
/**
 *
 */
export const getActions = (): HTMLElement | null => {
  const openSheetElement = get(shared.openSheet);
  return openSheetElement ? shared.getActions(openSheetElement) : null;
};

export const sheetV1: {
  closeEvent: EventTopicDefinition<void>;
  getOpenSheet: () => HTMLOcSheetV1Element | null;
  getContent: () => HTMLElement | null;
  switchEvent: EventTopicDefinition<void>;
  back: () => void;
  contentLoadedEvent: EventTopicDefinition<void>;
  getActions: () => HTMLElement | null;
  contentLoadingErrorEvent: EventTopicDefinition<void>;
  close: () => void;
  openEvent: EventTopicDefinition<void>;
  open: (sheetID: string) => void;
  getHeader: () => HTMLElement | null;
} = {
  open,
  close,
  back,
  getOpenSheet,
  getContent,
  getHeader,
  getActions,
  openEvent: defineEvent(),
  closeEvent: defineEvent(),
  switchEvent: defineEvent(),
  contentLoadedEvent: defineEvent(),
  contentLoadingErrorEvent: defineEvent(),
};
